import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { PublicPage } from "./pages/PublicPage";

const LoginPage = lazy(() => import("./pages/Admin").then((module) => ({ default: module.LoginPage })));
const RequireAdmin = lazy(() => import("./pages/Admin").then((module) => ({ default: module.RequireAdmin })));
const RequireOwner = lazy(() => import("./pages/Admin").then((module) => ({ default: module.RequireOwner })));
const AdminLayout = lazy(() => import("./pages/Admin").then((module) => ({ default: module.AdminLayout })));
const SongsPage = lazy(() => import("./pages/Admin").then((module) => ({ default: module.SongsPage })));
const CategoriesPage = lazy(() => import("./pages/Admin").then((module) => ({ default: module.CategoriesPage })));
const ImportPage = lazy(() => import("./pages/Admin").then((module) => ({ default: module.ImportPage })));
const HistoryPage = lazy(() => import("./pages/Admin").then((module) => ({ default: module.HistoryPage })));
const SubadminsPage = lazy(() => import("./pages/Admin").then((module) => ({ default: module.SubadminsPage })));
const SettingsPage = lazy(() => import("./pages/Admin").then((module) => ({ default: module.SettingsPage })));
const BolemeAdmin = lazy(() => import("./pages/BolemeAdmin"));

export default function App() {
  return (
    <Suspense fallback={<div className="admin-loading">正在加载页面...</div>}>
      <Routes>
        <Route path="/" element={<PublicPage />} />
        <Route path="/admin/login" element={<LoginPage />} />
        <Route element={<RequireAdmin />}>
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Navigate to="songs" replace />} />
            <Route path="songs" element={<SongsPage />} />
            <Route path="categories" element={<CategoriesPage />} />
            <Route element={<RequireOwner />}>
              <Route path="import" element={<ImportPage />} />
              <Route path="history" element={<HistoryPage />} />
              <Route path="subadmins" element={<SubadminsPage />} />
              <Route path="settings" element={<SettingsPage />} />
              <Route path="boleme/*" element={<BolemeAdmin />} />
            </Route>
          </Route>
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
}
